<script>
import { GameLauncher } from "@/mixins/game-launcher";

export default {
  name: "StakeSelection",

  mixins: [GameLauncher],

  data: () => ({
    selectedPriceIndex: null,
    stakesMC: [
      {
        value: 100,
        text: "1 MC",
        img: "/images/cards/challenge-friends/rumble.png",
      },
      {
        value: 200,
        text: "2 MC",
        img: "/images/cards/challenge-friends/frenzy.png",
      },
      {
        value: 500,
        text: "5 MC",
        img: "/images/cards/challenge-friends/rage.png",
      },
      {
        value: 1000,
        text: "10 MC",
        img: "/images/cards/challenge-friends/fury.png",
      },
      {
        value: 2000,
        text: "20 MC",
        img: "/images/cards/challenge-friends/storm.png",
      },
      {
        value: 5000,
        text: "50 MC",
        img: "/images/cards/challenge-friends/chaos.png",
      },
    ],
    stakesQC: [
      {
        value: 200000,
        text: "2K QC",
        img: "/images/cards/challenge-friends/rumble.png",
      },
      {
        value: 400000,
        text: "4K QC",
        img: "/images/cards/challenge-friends/frenzy.png",
      },
      {
        value: 1000000,
        text: "10K QC",
        img: "/images/cards/challenge-friends/rage.png",
      },
      {
        value: 4000000,
        text: "40K QC",
        img: "/images/cards/challenge-friends/fury.png",
      },
      {
        value: 10000000,
        text: "100K QC",
        img: "/images/cards/challenge-friends/storm.png",
      },
      {
        value: 20000000,
        text: "200K QC",
        img: "/images/cards/challenge-friends/chaos.png",
      },
    ],
  }),

  computed: {
    itemsToDisplay() {
      return this.QCMode ? this.stakesQC : this.stakesMC;
    },
  },

  methods: {
    selectPrice(item, index) {
      this.selectedPriceIndex = index;

      this.selectedQCStake = this.stakesQC[index]?.value;
      this.selectedMCStake = this.stakesMC[index]?.value;

      this.$emit("selectQCStake", this.stakesQC[index]?.value);
      this.$emit("selectMCStake", this.stakesMC[index]?.value);
    },
  },
};
</script>

<template>
  <div class="more-buy-in-wrapper">
    <div class="d-flex justify-space-around buy-in-flex-wrapper">
      <div
        v-for="(item, i) in itemsToDisplay"
        :key="i"
        :class="{ selected: selectedPriceIndex === i }"
        class="buy-in-container"
        style="z-index: 2"
        @click="selectPrice(item, i)"
      >
        <img class="buy-in-image" v-reload-on-fail :src="item.img" alt="stake" />
        <span
          class="stake-text white--text text-h5 text-sm-h4 font-weight-800 text-shadow-2"
        >
          {{ item.text }}
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.buy-in-flex-wrapper {
  @media screen and (max-width: 1262px) {
    gap: 10px;
  }

  @media screen and (max-width: 900px) {
    flex-wrap: wrap;
  }
}

.more-buy-in-wrapper {
  width: 100%;

  .buy-in-container {
    cursor: pointer;
    max-width: 30%;
    position: relative;
    transition: 0.2s all;

    .buy-in-image {
      width: 185px;
    }

    .stake-text {
      white-space: nowrap;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);

      @media screen and (max-width: 1264px) {
        font-size: 26px !important;
      }

      @media screen and (max-width: 400px) {
        font-size: 16px !important;
      }
    }

    &.selected {
      transform: scale(1.03);
    }

    &:hover::after,
    &.selected::after {
      content: "";
      position: absolute;
      border-radius: 8px;
      top: 0;
      left: 0;
      height: 98%;
      width: 100%;
      border: 1px solid var(--v-gold-base);
      box-shadow: 0 0 12px var(--v-gold-base);
    }

    &.selected::after {
      animation: pulse 2s infinite;
    }
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 7px var(--v-gold-base);
  }
  50% {
    box-shadow:
      0 0 15px var(--v-gold-base),
      0 0 5px var(--v-gold-base);
  }
  100% {
    box-shadow: 0 0 7px var(--v-gold-base);
  }
}
</style>
